<template>
  <section class="batch-modify">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" @click="$emit('back')">‹ 返回</button>
        <span>
          商品工作台　›　批量修改　›　
          <strong>{{ title }}</strong>
        </span>
      </div>
      <h1>批量修改{{ title }}</h1>
      <nav>
        <button v-for="tab in tabs" :key="tab.value" :class="{ active: mode === tab.value }" @click="mode = tab.value">
          {{ tab.label }}
        </button>
      </nav>
    </header>
    <main>
      <section class="panel">
        <div v-if="mode === 'products'" class="picked">
          <button @click="openSelector">选择商品</button>
          <span>
            已选择
            <b>{{ selected.length }}</b>
            个商品
          </span>
        </div>
        <!-- 按商品 ID 修改暂不开放
        <div v-if="mode === 'product_ids'" class="ids">
          <label>抖店商品 ID</label>
          <el-input v-model="idsText" type="textarea" :rows="3" placeholder="多个 ID 用逗号、空格或换行分隔，支持 Excel 粘贴" />
        </div>
        -->
        <div v-if="mode === 'range'" class="filters">
          <label v-for="field in shownFields" :key="field.key" class="field">
            <span>
              {{ field.label }}
              <small v-if="field.runtime">（需核验数据）</small>
            </span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filters.category_id"
              :categories="categories" />
            <el-date-picker
              v-else-if="field.date"
              v-model="filters[field.key]"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间" />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]" :aria-label="field.label + '匹配方式'">
                <el-option
                  v-for="option in field.matchOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label" />
              </el-select>
              <div v-if="field.range" class="range">
                <input v-model="filters[field.key + '_min']" placeholder="最小值" />
                <span>~</span>
                <input v-model="filters[field.key + '_max']" placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :aria-label="field.label"
                :disabled="filters[field.matchKey] === 'empty'"
                :placeholder="field.placeholder || '请输入' + field.label" />
            </div>
            <div v-else-if="field.range" class="range">
              <input v-model="filters[field.key + '_min']" placeholder="最小值" />
              <span>~</span>
              <input v-model="filters[field.key + '_max']" placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filters[field.key]" clearable>
              <el-option
                v-for="option in field.options"
                :key="String(option.value)"
                :value="option.value"
                :label="option.label" />
            </el-select>
            <input v-else v-model="filters[field.key]" :placeholder="field.placeholder || '请输入条件'" />
          </label>
        </div>
        <footer v-if="mode === 'range'" class="filter-actions">
          <doudian-batch-shop-scope v-model="shops" :shops="shopOptions" :disabled="confirming" />
          <div class="filter-buttons">
            <button class="more-search" @click="more = !more">{{ more ? '收起更多搜索 ▴' : '更多搜索 ▾' }}</button>
            <button :disabled="loading || confirming" @click="loadPreview(1)">查询</button>
            <button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p v-if="mode === 'range'" class="hint">
          不同条件同时满足才命中；一个 SKU 满足已设置的 SKU
          条件即可命中商品。条件筛选有些无法直接查询结果，通过数据命中来判断是否符合。
        </p>
      </section>
      <doudian-batch-common-options
        v-if="launches || feature === 'timer'"
        v-model="commonOptions"
        :disabled="confirming"
        :show-shelf-action="false" />
      <section class="panel methods">
        <h3>
          <i></i>
          修改内容
        </h3>
        <div class="method-body">
          <div v-if="feature === 'status'" class="rule-row">
            <el-radio-group v-model="action">
              <el-radio label="online">上架</el-radio>
              <el-radio label="offline">下架</el-radio>
            </el-radio-group>
            <p class="hint">
              预售结束后抖店会自动下架。重新上架需要先改现货发货模式，或延长预售时间。这里不代改发货模式。
            </p>
            <p v-if="action === 'online'" class="hint">上架一次最多 1000 个商品。</p>
          </div>
          <div v-else class="rule-row">
            <el-radio-group v-model="timerMode">
              <el-radio label="unify">统一设置</el-radio>
              <el-radio label="average">平均分配</el-radio>
            </el-radio-group>
            <div v-if="timerMode === 'unify'" class="rule-options">
              <el-date-picker
                v-model="onlineAt"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="上架时间，可空" />
              <el-date-picker
                v-model="offlineAt"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="下架时间，可空" />
            </div>
            <div v-else class="rule-options">
              <el-date-picker
                v-model="startAt"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="上架开始时间" />
              <el-date-picker
                v-model="endAt"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="上架结束时间" />
            </div>
            <p class="hint">
              两个时间不能相同。下架早于上架表示先下后上。排除商品后，其余商品保持预览里的时间。执行可能比设定时间晚约 1
              分钟。定时上下架不能恢复。
            </p>
            <p v-if="launches" class="hint">上架一次最多 1000 个商品。</p>
          </div>
          <div v-if="launches" class="rule-row price-floor-row">
            <span>SKU价格低于</span>
            <input v-model="priceFloor" placeholder="例如 9.90" />
            <span>元则不操作</span>
          </div>
        </div>
      </section>
      <section v-if="preview" class="panel preview">
        <header class="preview-summary">
          <span>
            当前预览
            <b>{{ preview.total }}</b>
            个，已排除 {{ excluded.length }} 个
          </span>
          <button class="plain" @click="preview = null">收起预览</button>
        </header>
        <div class="preview-details">
          <span>
            {{
              preview.needs_detail
                ? '有搜索命中词或过滤条件，执行时先读商品详情再上下架。'
                : '没有搜索命中词和过滤条件，执行时按本地数据直接上下架。'
            }}
          </span>
          <span v-if="launches">
            上架前校验必填尺码表，AI自动生成{{ commonOptions.auto_generate_size_chart ? '已开启' : '未开启' }}。
          </span>
          <span v-if="!previewCurrent" class="warning">条件已变化，请重新预览。</span>
          <span v-if="missingIds.length" class="warning">未找到的商品 ID：{{ missingIds.join('、') }}</span>
        </div>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>店铺 / 商品</th>
                <th>抖店商品 ID</th>
                <th>动作</th>
                <th>时间</th>
                <th>预计结果</th>
                <th>说明</th>
                <th>排除</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in preview.list" :key="item.id">
                <td>
                  <div class="preview-product">
                    <el-image class="preview-product-image" :src="productImage(item)" fit="cover">
                      <span slot="error">暂无图片</span>
                    </el-image>
                    <div>
                      <small>{{ item.shop_name }}</small>
                      <p>{{ item.product_title }}</p>
                    </div>
                  </div>
                </td>
                <td>{{ item.platform_product_id }}</td>
                <td>{{ item.next_action === 'offline' ? '下架' : '上架' }}</td>
                <td>{{ timeText(item) }}</td>
                <td>{{ resultNames[item.preview_result] || item.preview_result }}</td>
                <td>{{ item.skip_reason || item.error_msg || '—' }}</td>
                <td><el-checkbox :value="excluded.includes(Number(item.id))" @change="exclude(item.id, $event)" /></td>
              </tr>
              <tr v-if="!preview.list.length"><td colspan="7">暂无候选商品</td></tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="preview.page"
            :page-size="preview.limit"
            :total="preview.total"
            @current-change="loadPreview" />
        </footer>
      </section>
    </main>
    <footer class="actions">
      <button class="preview-button" :disabled="loading || confirming" @click="loadPreview(1)">
        {{ loading ? '加载中…' : '修改内容预览' }}
      </button>
      <button class="start" :disabled="loading || confirming || !previewCurrent" @click="createBatch">
        {{ confirming ? '处理中…' : '开始批量修改' }}
      </button>
      <label v-if="feature === 'status'">
        <input v-model="scheduled" type="checkbox" :disabled="confirming" @change="toggleSchedule" />
        定时执行
      </label>
      <button v-if="feature === 'status' && scheduled" class="time" :disabled="confirming" @click="openSchedule">
        {{ scheduledAt.slice(0, 16) }}
      </button>
    </footer>
    <div v-if="scheduleVisible" class="schedule-mask">
      <section class="schedule-modal" role="dialog" aria-modal="true" aria-label="定时执行">
        <header>
          <strong>定时执行</strong>
          <button aria-label="关闭" @click="closeSchedule">×</button>
        </header>
        <main>
          <el-date-picker
            v-model="scheduleDraft"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :clearable="false"
            placeholder="请选择执行时间" />
        </main>
        <footer>
          <button class="plain" @click="closeSchedule">取消</button>
          <button @click="confirmSchedule">确定</button>
        </footer>
      </section>
    </div>
    <product-selector-dialog
      @page-size-change="changeSelectorPageSize"
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="selectorPageSize"
      :page-sizes="[20, 50, 100, 500, 1000]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorJump"
      :page-fully-selected="selectorRows.length > 0 && selectorRows.every(isSelected)"
      :product-id="productId"
      :product-key="productId"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @tab-change="changeSelectorTab"
      @close="selectorVisible = false"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump-input="selectorJump = $event"
      @jump="changeSelectorPage(Number(selectorJump))"
      @confirm="confirmSelected">
      <template #filters>
        <doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="changeSelectorShop"
          @query="loadSelector(1)" />
      </template>
    </product-selector-dialog>
  </section>
</template>

<script>
import DoudianBatchShopScope from '@/components/DoudianBatchShopScope'
import {
  previewDoudianShelfBatch,
  createDoudianShelfBatch,
  getDoudianCategories,
  getAuthSuccessShopList,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import DoudianBatchCommonOptions from '@/components/DoudianBatchCommonOptions'
import { fields, pairedFields, defaults } from './batchModifyFilters'

export default {
  name: 'BatchModifyShelf',
  components: {
    DoudianBatchShopScope,
    DoudianCategoryCascader,
    DoudianProductSelectorFilters,
    DoudianBatchCommonOptions,
    ProductSelectorDialog
  },
  props: { feature: { type: String, default: 'status' } },
  data: () => ({
    tabs: [
      { value: 'range', label: '按范围修改' },
      { value: 'products', label: '按商品修改' }
      // { value: 'product_ids', label: '按商品 ID 修改' }
    ],
    mode: 'range',
    fields,
    filters: defaults(),
    more: false,
    shops: [],
    shopOptions: [],
    categories: [],
    selected: [],
    excluded: [],
    idsText: '',
    action: 'online',
    timerMode: 'unify',
    onlineAt: '',
    offlineAt: '',
    startAt: '',
    endAt: '',
    priceFloor: '',
    commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
    scheduled: false,
    scheduledAt: '',
    scheduleDraft: '',
    scheduleVisible: false,
    preview: null,
    signature: '',
    loading: false,
    confirming: false,
    previewRequest: 0,
    resultNames: { ready: '本地预计执行', skipped: '预计跳过', unknown: '待执行时核验' },
    selectorVisible: false,
    selectorTab: 'all',
    selectorLoading: false,
    selectorRows: [],
    selectorPageSize: 20,
    selectorPage: 1,
    selectorTotal: 0,
    selectorJump: 1,
    selectorShopId: '',
    selectorFilters: {
      category_id: { level1: [], level2: [], level3: [] },
      platform_product_id: '',
      product_title: '',
      created_at: [],
      tab_status: ''
    },
    draftSelected: [],
    selectorRequest: 0
  }),
  computed: {
    title() {
      return this.feature === 'timer' ? '定时上下架' : '上下架'
    },
    launches() {
      if (this.feature === 'status') return this.action === 'online'
      if (this.timerMode === 'average') return true
      return Boolean(this.onlineAt)
    },
    shownFields() {
      return this.fields
        .filter((field) => !Object.values(pairedFields).includes(field.key) && (!field.more || this.more))
        .map((field) =>
          pairedFields[field.key]
            ? {
                ...field,
                matchKey: pairedFields[field.key],
                matchOptions: this.fields.find((item) => item.key === pairedFields[field.key]).options
              }
            : field
        )
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil((this.selectorTab === 'selected' ? this.draftSelected.length : this.selectorTotal) / this.selectorPageSize)
      )
    },
    selectorProducts() {
      return this.selectorTab === 'selected'
        ? this.draftSelected.slice((this.selectorPage - 1) * this.selectorPageSize, this.selectorPage * this.selectorPageSize)
        : this.selectorRows
    },
    previewCurrent() {
      return Boolean(this.preview && this.signature === JSON.stringify(this.payload(false)))
    },
    missingIds() {
      return this.preview && Array.isArray(this.preview.missing_platform_product_ids)
        ? this.preview.missing_platform_product_ids
        : []
    }
  },
  watch: {
    shops: {
      deep: true,
      handler() {
        this.selected = []
        this.excluded = []
      }
    },
    mode() {
      this.excluded = []
      this.preview = null
    },
    timerMode() {
      this.preview = null
    }
  },
  mounted() {
    this.loadOptions()
  },
  beforeDestroy() {
    this.previewRequest++
    this.selectorRequest++
  },
  methods: {
    changeSelectorPageSize(size) {
      this.selectorPageSize = Number(size)
      this.selectorPage = 1
      this.loadSelector(1)
    },
    dataOf(response) {
      if (!response || Number(response.code) !== 200) throw new Error(response?.message || '请求失败')
      return response.data
    },
    message(error) {
      return error?.response?.data?.message || error?.message || '请求失败'
    },
    async loadOptions() {
      try {
        const data = this.dataOf(await getAuthSuccessShopList())
        this.shopOptions = (Array.isArray(data) ? data : data.list || data.data || []).filter(
          (shop) => shop.selectable !== false
        )
      } catch (error) {
        this.$message.error(this.message(error))
      }
      try {
        const data = this.dataOf(await getDoudianCategories({ shop_type: 1 }))
        const map = (items) =>
          items.map((item) => ({
            ...item,
            category_id: item.id || item.category_id,
            category_name: item.name || item.category_name,
            children: map(item.children || [])
          }))
        this.categories = map(Array.isArray(data) ? data : data.list || data.data || [])
      } catch (error) {
        this.$message.error(this.message(error))
      }
    },
    split(text) {
      return String(text)
        .split(/[,，\s]+/)
        .filter(Boolean)
    },
    options() {
      const floor = this.launches ? this.priceFloor.trim() || null : null
      if (this.feature === 'status') {
        return {
          action: this.action,
          price_floor_yuan: floor,
          auto_generate_size_chart: this.commonOptions.auto_generate_size_chart
        }
      }
      if (this.timerMode === 'average') {
        return {
          mode: 'average',
          start_at: this.startAt || null,
          end_at: this.endAt || null,
          virtual_offline: false,
          price_floor_yuan: floor || null,
          auto_generate_size_chart: this.commonOptions.auto_generate_size_chart
        }
      }
      return {
        mode: 'unify',
        online_at: this.onlineAt || null,
        offline_at: this.offlineAt || null,
        price_floor_yuan: floor || null,
        auto_generate_size_chart: this.commonOptions.auto_generate_size_chart
      }
    },
    payload(schedule = true) {
      const filter = { shop_ids: [...this.shops], excluded_product_ids: [...this.excluded] }
      Object.keys(this.filters).forEach((key) => {
        const value = this.filters[key]
        if (value !== '' && value !== null && !(Array.isArray(value) && !value.length))
          filter[key] = typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value
      })
      if (filter.platform_product_id) filter.platform_product_id = [...new Set(this.split(filter.platform_product_id))]
      if (this.mode !== 'range') {
        delete filter.status
        delete filter.created_at
        delete filter.category_id
        filter.platform_product_id =
          this.mode === 'products'
            ? [...new Set(this.selected.map((item) => String(item.platform_product_id)))]
            : [...new Set(this.split(this.idsText))]
      }
      Object.keys(filter)
        .filter((key) => /_(min|max)$/.test(key) || ['brand_id', 'freight_id'].includes(key))
        .forEach((key) => {
          if (/_(min|max)$/.test(key)) filter[key] = Number(filter[key])
        })
      const payload = {
        selection_mode: this.mode,
        product_filter: filter,
        rules: [{ type: this.feature === 'timer' ? 8 : 7, options: this.options() }]
      }
      if (schedule && this.feature === 'status' && this.scheduled) payload.scheduled_at = this.scheduledAt
      return payload
    },
    validate() {
      if (this.feature === 'status' && !['online', 'offline'].includes(this.action)) throw new Error('请选择上架或下架')
      if (this.launches && this.priceFloor.trim() && !/^\d+(\.\d{1,2})?$/.test(this.priceFloor.trim()))
        throw new Error('低价阈值必须大于 0，最多两位小数')
      if (this.launches && this.priceFloor.trim() && Number(this.priceFloor) <= 0) throw new Error('低价阈值必须大于 0')
      if (this.feature === 'timer' && this.timerMode === 'unify' && !this.onlineAt && !this.offlineAt)
        throw new Error('请至少填写一个时间')
      if (this.feature === 'timer' && this.timerMode === 'unify' && this.onlineAt && this.onlineAt === this.offlineAt)
        throw new Error('上架时间和下架时间不能相等')
      if (
        this.feature === 'timer' &&
        this.timerMode === 'average' &&
        (!this.startAt || !this.endAt || this.startAt >= this.endAt)
      )
        throw new Error('请填写开始早于结束的上架时间')
      const payload = this.payload(false)
      const ids = payload.product_filter.platform_product_id
      if (this.mode !== 'range' && (!ids || !ids.length)) throw new Error('请选择商品或输入抖店商品 ID')
      if (ids && (ids.length > 10000 || ids.some((id) => !/^[1-9][0-9]{0,199}$/.test(id))))
        throw new Error('商品 ID 必须是数字，最多10000个')
      return payload
    },
    async loadPreview(page = 1) {
      if (this.loading || this.confirming) return
      let payload
      try {
        payload = this.validate()
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const signature = JSON.stringify(payload)
      const request = ++this.previewRequest
      this.loading = true
      this.signature = ''
      try {
        const data = this.dataOf(await previewDoudianShelfBatch(this.feature, { ...payload, page, limit: 20 }))
        if (request !== this.previewRequest || this._isDestroyed) return
        if (!Array.isArray(data?.list) || !Number.isInteger(data.total)) throw new Error('预览响应格式错误')
        this.preview = data
        this.signature = signature
        const kept = Math.max(0, Number(data.total) - this.excluded.length)
        if (this.launches && kept > 1000) this.$message.warning('上架商品数量不能超过1000个')
      } catch (error) {
        if (request === this.previewRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.previewRequest) this.loading = false
      }
    },
    exclude(id, value) {
      this.excluded = value
        ? [...new Set([...this.excluded, Number(id)])]
        : this.excluded.filter((item) => item !== Number(id))
      this.signature = ''
    },
    resetFilters() {
      this.filters = defaults()
      this.excluded = []
      this.signature = ''
    },
    timeText(item) {
      return [item.online_at, item.offline_at].filter(Boolean).join(' / ') || '立即'
    },
    formatScheduleTime(date = new Date(Date.now() + 60000)) {
      const pad = (value) => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}`
    },
    toggleSchedule() {
      if (!this.scheduled) {
        this.scheduledAt = ''
        this.closeSchedule()
      } else if (!this.scheduledAt) this.scheduledAt = this.formatScheduleTime() + ':00'
    },
    openSchedule() {
      this.scheduleDraft = this.scheduledAt.slice(0, 16) || this.formatScheduleTime()
      this.scheduleVisible = true
    },
    closeSchedule() {
      this.scheduleVisible = false
    },
    confirmSchedule() {
      const timestamp = new Date(this.scheduleDraft.replace(' ', 'T') + '+08:00').getTime()
      if (
        !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(this.scheduleDraft) ||
        !Number.isFinite(timestamp) ||
        timestamp <= Date.now()
      )
        return this.$message.warning('请选择未来的执行时间')
      this.scheduledAt = this.scheduleDraft + ':00'
      this.closeSchedule()
    },
    async createBatch() {
      if (this.loading || this.confirming) return
      try {
        this.validate()
        if (!this.previewCurrent) throw new Error('请先按当前条件预览')
        const kept = Math.max(0, Number(this.preview.total) - this.excluded.length)
        if (kept < 1 || kept > 10000) throw new Error('候选商品必须为1–10000件')
        if (this.launches && kept > 1000) throw new Error('上架商品数量不能超过1000个')
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const payload = this.payload()
      const frozen = JSON.stringify(payload)
      this.confirming = true
      try {
        await this.$confirm(`候选${this.preview.total}件。执行时以平台详情为准。`, '确认修改')
        if (!this.previewCurrent || frozen !== JSON.stringify(this.payload()))
          throw new Error('条件已变化，请重新预览并确认')
        this.dataOf(await createDoudianShelfBatch(this.feature, payload))
        if (!this._isDestroyed) {
          this.$message.success('任务已创建，请查看批量修改记录')
          this.$emit('created')
        }
      } catch (error) {
        if (error !== 'cancel' && error !== 'close' && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        this.confirming = false
      }
    },
    productId(item) {
      return Number(item.distribute_product_id || item.id)
    },
    productTitle(item) {
      return item.product_title || item.title || ''
    },
    productImage(item) {
      return item.main_image || item.img || ''
    },
    productPrice(item) {
      return item.product_price == null ? '价格待定' : '¥' + Number(item.product_price).toFixed(2)
    },
    isSelected(item) {
      return this.draftSelected.some((row) => this.productId(row) === this.productId(item))
    },
    toggleProduct(item) {
      if (
        !this.isSelected(item) &&
        this.draftSelected.length &&
        Number(this.draftSelected[0].shop_id) !== Number(item.shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      this.draftSelected = this.isSelected(item)
        ? this.draftSelected.filter((row) => this.productId(row) !== this.productId(item))
        : [...this.draftSelected, item]
    },
    togglePage() {
      const pageIds = this.selectorRows.map(this.productId)
      const all = this.selectorRows.every(this.isSelected)
      this.draftSelected = all
        ? this.draftSelected.filter((row) => !pageIds.includes(this.productId(row)))
        : [...this.draftSelected, ...this.selectorRows.filter((item) => !this.isSelected(item))]
    },
    changeSelectorTab(tab) {
      this.selectorTab = tab
      this.selectorPage = 1
      this.selectorJump = 1
    },
    changeSelectorPage(page) {
      const next = Math.min(this.selectorPages, Math.max(1, Number(page) || 1))
      if (this.selectorTab === 'all') return this.loadSelector(next)
      this.selectorPage = next
      this.selectorJump = next
    },
    changeSelectorShop(shopId) {
      this.selectorShopId = shopId
      this.loadSelector(1)
    },
    openSelector() {
      this.selectorShopId = this.selected[0]?.shop_id || ''
      this.draftSelected = [...this.selected]
      this.selectorTab = 'all'
      this.selectorVisible = true
      this.loadSelector(1)
    },
    async confirmSelected() {
      const shopId = Number(this.draftSelected[0]?.shop_id)
      if (!shopId || this.draftSelected.some((item) => Number(item.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品')
      this.shops = [shopId]
      await this.$nextTick()
      this.selected = [...this.draftSelected]
      this.selectorVisible = false
      this.excluded = []
    },
    async loadSelector(page) {
      const request = ++this.selectorRequest
      this.selectorLoading = true
      try {
        const data = this.dataOf(
          await getProductSelectorProducts({
            page: Math.max(1, page),
            page_size: this.selectorPageSize,
            ...Object.fromEntries(
              Object.entries(this.selectorFilters).filter(
                ([, value]) => value != null && value !== '' && (!Array.isArray(value) || value.length)
              )
            ),
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
          })
        )
        if (request !== this.selectorRequest || this._isDestroyed) return
        if (!Array.isArray(data?.list)) throw new Error('商品响应格式错误')
        this.selectorRows = data.list
        this.selectorPage = Math.max(1, page)
        this.selectorJump = this.selectorPage
        this.selectorTotal = data.pagination?.total ?? data.total
      } catch (error) {
        if (request === this.selectorRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.selectorRequest) this.selectorLoading = false
      }
    }
  }
}
</script>

<style scoped src="./batch-modify.css"></style>
